module.exports = __webpack_public_path__ + "static/media/depository-safes.c27d929c.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/depository-safes.png
// module id = 1282
// module chunks = 0